export function applyTraits(Class, Traits) {

  for (let Trait of Traits) {

    const traitMethods = Object.getOwnPropertyNames(Trait.prototype);

    for (let method of traitMethods) {

      if (method === 'constructor') {
        continue;
      }

      if (typeof Class.prototype[method] === 'function') {
        // eslint-disable-next-line no-console
        console.info(`Method ${method} already exists in ${Class.name}. Skipping...`);
        continue;
      }

      Class.prototype[method] = Trait.prototype[method];

    }

  }

  return Class;

}